export default __webpack_public_path__ + "static/bucky_massage-caebce063d7424ab58c2f3ac3e493054.jpeg";